import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import logo from '~/assets/img/gpaLogo.png'
import { PersonalTrainerSignUpForm } from '~/forms/PersonalTrainerSignUpForm'
import { authenticatePersonalTrainer } from '~/modules/authentication/services'
import { PersonalTrainerSingUpDTO } from '~/modules/personalTrainer/schema'
import { trialSignUpPersonalTrainer } from '~/modules/personalTrainer/services'

export function TrialRegister() {
  const navigate = useNavigate()

  const handleSubmit = useCallback(
    async (payload: PersonalTrainerSingUpDTO) => {
      const data = await trialSignUpPersonalTrainer(payload)
      if (data) {
        await authenticatePersonalTrainer({
          documentNumber: data.documentNumber,
          password: payload.password!,
        })
        navigate('/', { replace: true })
      }
    },
    [navigate],
  )

  return (
    <div
      className='flex flex-col items-center justify-center bg-gpa-blue-50
        min-h-screen py-12'
    >
      <img src={logo} alt='GPA' />
      <p className='my-4 font-semibold text-center'>
        Registre-se com 5 dias de uso gratuito para testar o GPA Studio Pro!
      </p>

      <PersonalTrainerSignUpForm onSubmit={handleSubmit} />
    </div>
  )
}
